import { render, staticRenderFns } from "./PriceRecordsItems.vue?vue&type=template&id=aafa08ae&"
import script from "./PriceRecordsItems.vue?vue&type=script&lang=js&"
export * from "./PriceRecordsItems.vue?vue&type=script&lang=js&"
import style0 from "./PriceRecordsItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports